import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "button-warning" }
const _hoisted_2 = { class: "error-msg" }
const _hoisted_3 = { class: "page-header" }
const _hoisted_4 = { class: "input-group input-group-sm" }
const _hoisted_5 = { class: "input-group input-group-sm" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "optional-btn-label" }
const _hoisted_9 = {
  key: 1,
  class: "table table-sm"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 0,
  class: "badge bg-secondary ms-1",
  title: "Provisioned fleet-wide and managed by the blades team; view only"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["title"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "row-actions" }
const _hoisted_17 = ["onClick", "title"]
const _hoisted_18 = { class: "optional-btn-label" }
const _hoisted_19 = {
  key: 0,
  class: "alert-history-row"
}
const _hoisted_20 = {
  colspan: 8,
  style: {"padding":"0.5em 1.5em 1em 1.5em","background":"#f8f9fa"}
}
const _hoisted_21 = {
  key: 0,
  style: {"padding":"1em"}
}
const _hoisted_22 = {
  key: 1,
  class: "alert alert-warning",
  style: {"margin":"0.5em 0"}
}
const _hoisted_23 = {
  key: 2,
  style: {"padding":"0.5em","color":"#6c757d"}
}
const _hoisted_24 = {
  key: 3,
  class: "table table-sm table-bordered alert-history-table"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_PrettifyJSON = _resolveComponent("PrettifyJSON")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_threshold_config_modal = _resolveComponent("threshold-config-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.errorMsg), 1)
    ], 512), [
      [_vShow, _ctx.errorMsg.length > 0]
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h1", { title: "Alarms triggered off thresholds in our database" }, "Alarms", -1)),
        _createElementVNode("form", {
          class: "date-picker-form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshAlertHistory && _ctx.refreshAlertHistory(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "input-group-text" }, "From", -1)),
            _createVNode(_component_datepicker, {
              modelValue: _ctx.pickerStartDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pickerStartDate) = $event)),
              onfocusout: _ctx.pushEndDate(),
              "upper-limit": _ctx.pickerEndDate,
              typeable: "",
              inputFormat: _ctx.dateFormat,
              class: "input-sm form-control"
            }, null, 8, ["modelValue", "onfocusout", "upper-limit", "inputFormat"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "input-group-text" }, "To", -1)),
            _createVNode(_component_datepicker, {
              modelValue: _ctx.pickerEndDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pickerEndDate) = $event)),
              "lower-limit": _ctx.pickerStartDate,
              "upper-limit": new Date(),
              typeable: "",
              inputFormat: _ctx.dateFormat,
              class: "input-sm form-control"
            }, null, 8, ["modelValue", "lower-limit", "upper-limit", "inputFormat"])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary btn-sm"
          }, "Update", -1))
        ], 32)
      ]),
      _cache[19] || (_cache[19] = _createElementVNode("h2", { title: "The configurable thresholds for a selection of sensors" }, "Thresholds", -1)),
      (_ctx.thresholds_loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Loading..."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.thresholds.length == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "There are no thresholds configured on this platform."))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNewThreshold())),
              title: "new threshold",
              style: {"margin":"1em"}
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_vue_feather, {
                  type: "plus-square",
                  size: "16"
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" Add new threshold ", -1))
              ])
            ]),
            (_ctx.thresholds.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                  _cache[18] || (_cache[18] = _createElementVNode("thead", { class: "thead thead-dark" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"width":"30px"}
                      }),
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"min-width":"150px"}
                      }, "Name"),
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"width":"260px"}
                      }, "Description"),
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"min-width":"150px"}
                      }, "Selector"),
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"width":"90px"}
                      }, "Severity"),
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"width":"90px"}
                      }, "Value"),
                      _createElementVNode("th", {
                        scope: "col",
                        style: {"width":"160px"}
                      }, "Created at"),
                      _createElementVNode("th", { scope: "col" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thresholds, (threshold) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: threshold.ThresholdID
                      }, [
                        _createElementVNode("tr", {
                          class: _normalizeClass({
                  'table-secondary': !threshold.Enabled,
                  clickable: true,
                }),
                          onClick: ($event: any) => (_ctx.toggleAlertHistory(threshold.ThresholdID))
                        }, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_vue_feather, {
                              type: _ctx.expandedHistoryRows.has(threshold.ThresholdID) ? 'chevron-down' : 'chevron-right',
                              size: "14"
                            }, null, 8, ["type"])
                          ]),
                          _createElementVNode("td", {
                            title: 'threshold ID ' + threshold.ThresholdID
                          }, [
                            _createTextVNode(_toDisplayString(threshold.Name) + " ", 1),
                            (threshold.Managed)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " managed "))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_11),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", {
                              class: _normalizeClass([
                      'description-cell',
                      {
                        clamped: !_ctx.expandedDescriptions.has(threshold.ThresholdID),
                      },
                    ])
                            }, _toDisplayString(threshold.Description), 3),
                            (_ctx.isLongDescription(threshold.Description))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: "#",
                                  class: "see-more-link",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleDescription(threshold.ThresholdID)), ["stop","prevent"])
                                }, _toDisplayString(_ctx.expandedDescriptions.has(threshold.ThresholdID) ? "See less" : "See more"), 9, _hoisted_13))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_PrettifyJSON, {
                              objectToPrettify: threshold.Selector,
                              "nested-primitives": true
                            }, null, 8, ["objectToPrettify"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(threshold.Severity), 1),
                          _createElementVNode("td", {
                            title: threshold.Selector.reference ? 'multiplier of the reference sensor' : ''
                          }, [
                            _createTextVNode(_toDisplayString(threshold.Value), 1),
                            (threshold.Selector.reference)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " ×"))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_14),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(threshold.CreatedAt, false, false)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_16, [
                              (threshold.DashboardUID)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: _ctx.diagnosisLink(threshold.DashboardUID),
                                    class: "btn btn-outline-info btn-sm",
                                    title: "open diagnosis dashboard",
                                    target: "_blank",
                                    rel: "noopener",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_vue_feather, {
                                        type: "activity",
                                        size: "12"
                                      }),
                                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "optional-btn-label" }, "Diagnosis", -1))
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-outline-primary btn-sm",
                                onClick: _withModifiers(($event: any) => (_ctx.showConfigureThreshold(threshold)), ["stop"]),
                                title: threshold.Managed ? 'view' : 'configure'
                              }, [
                                _createVNode(_component_vue_feather, {
                                  type: threshold.Managed ? 'eye' : 'tool',
                                  size: "12"
                                }, null, 8, ["type"]),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(threshold.Managed ? "View" : "Configure"), 1)
                              ], 8, _hoisted_17)
                            ])
                          ])
                        ], 10, _hoisted_10),
                        (_ctx.expandedHistoryRows.has(threshold.ThresholdID))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                              _createElementVNode("td", _hoisted_20, [
                                (_ctx.alertHistoryLoading.has(threshold.ThresholdID))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[11] || (_cache[11] = [
                                      _createElementVNode("span", null, "Loading alert history...", -1)
                                    ]))]))
                                  : (_ctx.alertHistoryCache[threshold.ThresholdID]?.grafanaError)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createVNode(_component_vue_feather, {
                                          type: "alert-triangle",
                                          size: "14"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.alertHistoryCache[threshold.ThresholdID].grafanaError), 1)
                                      ]))
                                    : (_ctx.alertHistoryCache[threshold.ThresholdID]?.history.length === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " No alerts in selected period "))
                                      : (_ctx.alertHistoryCache[threshold.ThresholdID]?.history.length > 0)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
                                            _createElementVNode("thead", null, [
                                              _createElementVNode("tr", null, [
                                                _cache[12] || (_cache[12] = _createElementVNode("th", null, "Fired at", -1)),
                                                _cache[13] || (_cache[13] = _createElementVNode("th", null, "Asset", -1)),
                                                _cache[14] || (_cache[14] = _createElementVNode("th", null, "Blade", -1)),
                                                _cache[15] || (_cache[15] = _createElementVNode("th", null, "Node", -1)),
                                                _cache[16] || (_cache[16] = _createElementVNode("th", null, "Duration", -1)),
                                                (threshold.DashboardUID)
                                                  ? (_openBlock(), _createElementBlock("th", _hoisted_25, "Diagnosis"))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertHistoryCache[threshold.ThresholdID].history, (entry, idx) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(new Date(entry.time).toISOString(), false, false)), 1),
                                                  _createElementVNode("td", null, _toDisplayString(entry.asset || "-"), 1),
                                                  _createElementVNode("td", null, _toDisplayString(entry.blade || "-"), 1),
                                                  _createElementVNode("td", null, _toDisplayString(entry.node || "-"), 1),
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDuration(entry.durationMs, entry.time)), 1),
                                                  (threshold.DashboardUID)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                                        _createVNode(_component_router_link, {
                                                          to: _ctx.diagnosisLink(threshold.DashboardUID, entry, threshold.Selector),
                                                          title: "open diagnosis dashboard around this alert's time",
                                                          target: "_blank",
                                                          rel: "noopener"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_vue_feather, {
                                                              type: "external-link",
                                                              size: "12"
                                                            }),
                                                            _cache[17] || (_cache[17] = _createTextVNode(" View ", -1))
                                                          ]),
                                                          _: 1
                                                        }, 8, ["to"])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (_ctx.selected_threshold)
        ? (_openBlock(), _createBlock(_component_threshold_config_modal, {
            key: 2,
            selected_threshold: _ctx.selected_threshold,
            sensorTagOptions: _ctx.sensor_tag_options,
            onClearSelectedThreshold: _ctx.onClearSelectedThreshold,
            onSavedThreshold: _ctx.addSavedThreshold,
            onDeletedThreshold: _ctx.handleDeletedThreshold
          }, null, 8, ["selected_threshold", "sensorTagOptions", "onClearSelectedThreshold", "onSavedThreshold", "onDeletedThreshold"]))
        : _createCommentVNode("", true)
    ])
  ]))
}